import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};


let app = {
    debug: false,
};
window.app = app || {};

import Tab from 'bootstrap/js/dist/tab';
onFind('[data-bs-toggle="tab"]',function (element) {
    new Tab(element)
});

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({
    submitOnReset: true
});

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();

import * as fetchModal from './scripts/fetch-modal';
fetchModal.init();

import Modal from 'bootstrap/js/dist/modal';
onFind('[data-bs-toggle="modal"]',function (element) {
    new Modal(element);
});

import * as datepicker from '@elements/datepicker';
datepicker.init();

import * as rangeDatepicker from '@elements/datepicker-range';
rangeDatepicker.init();

import * as activateTab from './scripts/activate-tab';
activateTab.init();